"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = require("semantic-ui-react");

var _PanelGetFeatureInfo = require("./PanelGetFeatureInfo.css");

var _PanelGetFeatureInfo2 = _interopRequireDefault(_PanelGetFeatureInfo);

var _reactGoogleCharts = require("react-google-charts");

var _reactGoogleCharts2 = _interopRequireDefault(_reactGoogleCharts);

var _chromaJs = require("chroma-js");

var _chromaJs2 = _interopRequireDefault(_chromaJs);

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

require("moment/locale/ca");

var _utils = require("../../common/utils");

var _utils2 = _interopRequireDefault(_utils);

var _share = require("../../utils/share");

var _share2 = _interopRequireDefault(_share);

var _constants = require("../../utils/constants");

var CONSTANTS = _interopRequireWildcard(_constants);

var _mapstylergl = require("../../mapstylergl/mapstylergl");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PanelGetFeatureInfo = function (_Component) {
  _inherits(PanelGetFeatureInfo, _Component);

  function PanelGetFeatureInfo() {
    _classCallCheck(this, PanelGetFeatureInfo);

    var _this = _possibleConstructorReturn(this, (PanelGetFeatureInfo.__proto__ || Object.getPrototypeOf(PanelGetFeatureInfo)).call(this));

    _this.toggleVisibilityEditPanel = function () {
      return _this.setState({ visibleEditPanel: !_this.state.visibleEditPanel });
    };

    _this.renderFooterInfoWindow = function (colorFont, colorBgSaturate) {
      return _react2.default.createElement(
        "div",
        { className: _PanelGetFeatureInfo2.default.itemFooter },
        _react2.default.createElement(
          _semanticUiReact.Label,
          {
            basic: true,
            size: "mini",
            horizontal: true,
            style: { color: colorFont, backgroundColor: colorBgSaturate }
          },
          _this.props.featureInfo.properties && _this.props.featureInfo.properties.font ? "Font: " + _this.props.featureInfo.properties.font : ""
        )
      );
    };

    _this.handleDismiss = function () {
      _this.setState({ visibleEditPanel: false });
      _this.props.showGetFeatureInfo(false);
    };

    _this.activeField = "";
    _this.state = {
      visibleEditPanel: true,
      dataMax: null
    };
    return _this;
  }

  _createClass(PanelGetFeatureInfo, [{
    key: "addSufixValue",
    value: function addSufixValue(field, suffix) {
      if (field.indexOf(suffix) === -1) {
        field = "" + field + suffix;
      }
      return field;
    }
  }, {
    key: "getActiveField",
    value: function getActiveField() {
      var activeField = void 0;
      this.props.thematics.map(function (visualitzacio) {
        if (visualitzacio.isVisible) {
          activeField = visualitzacio.field;
        }
      });
      return activeField;
    }
  }, {
    key: "getDaysRang",
    value: function getDaysRang() {
      var timemin = (0, _moment2.default)(this.props.timerange.timemin);
      var timemax = (0, _moment2.default)(this.props.timerange.timemax);
      return this.props.timerange.timemin === this.props.timerange.timemax ? "( 1 dia )" : "( " + timemax.add(1, "days").diff(timemin, "days") + " dies )";
    }
  }, {
    key: "getCalcValuesInfo",
    value: function getCalcValuesInfo(timestamps) {
      var horafiltremin = this.props.calcdatafieldsOptions.horafiltremin;
      var horafiltremax = this.props.calcdatafieldsOptions.horafiltremax;
      //custom single day
      if (horafiltremax === CONSTANTS.OPT_ULTIMAHORA.value) {
        var hours = new Date(timestamps[timestamps.length - 1]).getHours();
        horafiltremax = hours;
        horafiltremin = this.props.timerange.tipus === CONSTANTS.TODAY ? horafiltremin : hours;
      }
      /*
      if (horafiltremin === CONSTANTS.OPT_ULTIMAHORA.value) {
      const hours = new Date(timestamps[timestamps.length - 1]).getHours();
      horafiltremin = hours;
      }
      */
      //const horamin = this.props.calcdatafieldsOptions.granularitat === CONSTANTS.GRANULARITAT_DIES ? " 00:00" : ` ${horafiltremin}:00`;
      //const horamax = this.props.calcdatafieldsOptions.granularitat === CONSTANTS.GRANULARITAT_DIES ? " 00:00" : ` ${horafiltremax}:00`;
      //const formtedMax = this.formatDateMoment(`${this.props.calcdatafieldsOptions.datemin}${hora}`);
      //const formtedMin = this.formatDateMoment(`${this.props.calcdatafieldsOptions.datemax}${hora}`);
      var horamin = " " + horafiltremin + ":00";
      var horamax = " " + horafiltremax + ":00";
      var formtedMax = _share2.default.formatDateMoment("" + this.props.timerange.timemin + horamin);
      var formtedMin = _share2.default.formatDateMoment("" + this.props.timerange.timemax + horamax);
      return formtedMax + ":" + horamax + "  - " + formtedMin + ":" + horamin;
    }
  }, {
    key: "getTimeStampFromCurrentValuePluja",
    value: function getTimeStampFromCurrentValuePluja(currentValue, arrayChart, value, timestampsLocal) {
      var currentimestamps = null;
      if (value === "_mean" || value === "_sum") {

        return null;
      } else {
        for (var i = 1; i < arrayChart.length; i++) {
          if (currentValue && currentValue !== "null") {
            if (arrayChart[i][1].toFixed(1) === currentValue.toFixed(1)) {
              //currentimestamps = moment(arrayChart[i][0]).format("YYYY-MM-DD HH:mm");
              currentimestamps = (0, _moment2.default)(timestampsLocal[i]).format("YYYY-MM-DD HH:mm");
            }
          }
        }
        return currentimestamps;
      }
    }
  }, {
    key: "getTimeStampFromCurrentValue",
    value: function getTimeStampFromCurrentValue(currentValue, JSONActiveFiles, timestamps) {
      var _newKeys = Object.keys(JSONActiveFiles);
      var currentimestamps = null;
      _newKeys.forEach(function (item, index) {
        if (JSONActiveFiles[item] === currentValue) {
          currentimestamps = timestamps[item];
        }
      });
      return currentimestamps;
    }
  }, {
    key: "createArray",
    value: function createArray(colorFont, colorBG) {
      var _this2 = this;

      var feature = this.props.featureInfo;
      this.activeField = this.getActiveField();
      var timestamps = this.props.timerange.timestamps;
      var timestampsLocal = [];
      if (feature.properties.data && JSON.parse(feature.properties.data)) {
        try {
          timestampsLocal = _share2.default.changeFormatArrayString(Object.values(JSON.parse(feature.properties.data)));
          if (!timestampsLocal || timestampsLocal.length === 0) {
            timestampsLocal = timestamps;
          }
        } catch (err) {
          //console.info(err);
          timestampsLocal = timestamps;
        }
      } else {
        timestampsLocal = timestamps;
      }
      //console.info(timestampsLocal);
      var tipus = this.props.timerange.tipus;
      var alias = this.props.selectedfieldsLabels;
      var calcdatafieldsCalculs = this.props.calcdatafieldsCalculs;
      var _newGA = [];
      var _valueMostra = [];
      var dateValuesObj = {};
      var optionsField = _share2.default.getObtionsByActiveField(this.activeField);
      //console.info("optionsField0",optionsField);
      var arraySufixActivates = _share2.default.generateListCalcValues(calcdatafieldsCalculs);
      var labelChart = alias[this.activeField] === "Pluja mm" ? "Pluja mm" : alias[this.activeField];
      _newGA.push(["temps", labelChart]);
      var JSONActiveFiles = JSON.parse(feature.properties[this.activeField]);
      //console.info(JSONActiveFiles);
      //console.info(feature.properties[this.activeField]);
      if (this.activeField.indexOf(CONSTANTS.CAMP_NOM_PLUJA) !== -1 || this.activeField.indexOf(CONSTANTS.CAMP_NOM_NEU) !== -1) {
        var _newValues = Object.values(JSONActiveFiles);
        _newValues.forEach(function (item, index) {
          if (item === null) {
            JSONActiveFiles[index] = 0;
          }
        });
      }
      var countTimes = timestampsLocal.length < timestamps.length ? timestamps.length : timestampsLocal.length;
      // ? timestampsLocal.length
      // : timestamps.length;
      var _newValues2 = Object.values(JSONActiveFiles);

      _newValues2.forEach(function (item, index) {
        if (item !== null) {
          JSONActiveFiles[index] = item;
        }
      });

      for (var i = 0; i < countTimes; i++) {
        if (typeof JSONActiveFiles[i] === "number") {

          var _data = isNaN(new Date(timestamps[i]).getTime()) ? timestamps[i] : new Date(timestamps[i]);
          var _datalocal = isNaN(new Date(timestampsLocal[i]).getTime()) ? timestampsLocal[i] : new Date(timestampsLocal[i]);
          if (this.activeField.indexOf(CONSTANTS.CAMP_NOM_PLUJA) !== -1 || this.activeField.indexOf(CONSTANTS.CAMP_NOM_NEU) !== -1) {
            var _hora = parseInt((0, _moment2.default)(timestamps[i]).format("H"));
            if ((0, _moment2.default)(timestamps[i]).format("YYYY-MM-DD") === (0, _moment2.default)(timestamps[i - 1]).format("YYYY-MM-DD") && _hora >= 0 && _hora <= 23) {
              var _horaAnterior = parseInt((0, _moment2.default)(timestamps[i - 1]).format("H"));

              if (_hora - _horaAnterior < 5) {

                var _anterior = JSONActiveFiles[i - 1];

                if (isNaN(_anterior)) {
                  if (JSONActiveFiles[i - 2] && parseInt((0, _moment2.default)(timestamps[i - 2]).format("H")) === _horaAnterior) {
                    _anterior = JSONActiveFiles[i - 2];
                  } else {
                    _anterior = 0;
                  }
                }
                _anterior = _anterior <= 0 ? 0 : _anterior;
                var valor = JSONActiveFiles[i] - _anterior;

                valor = valor >= 0 ? valor : 0; // >= no cambia
                _newGA.push([_data, valor]);
                _valueMostra.push(valor);
              }
            } else {
              _newGA.push([_data, JSONActiveFiles[i]]);
              _valueMostra.push(JSONActiveFiles[i]);
            }
          } else {
            _newGA.push([_datalocal, JSONActiveFiles[i]]);
            _valueMostra.push(JSONActiveFiles[i]);
          }
        }
      }
      //console.info("_newGA", _newGA);
      //console.info("_valueMostra", _valueMostra);
      if (this.activeField.indexOf(CONSTANTS.CAMP_NOM_PLUJA) !== -1 || this.activeField.indexOf(CONSTANTS.CAMP_NOM_NEU) !== -1) {
        var newFilterValue = _valueMostra.filter(function (_valueMostra) {
          return _valueMostra > 0;
        });
        var arrayStats = newFilterValue.length > 0 ? new _mapstylergl.ArrayStatics(newFilterValue) : new _mapstylergl.ArrayStatics(_valueMostra);
        var estats = arrayStats.getBasicsStats(2);
        //Math.min(...numbers) )
        optionsField.min = estats.basics.min;
        optionsField.max = estats.basics.max;
        arraySufixActivates.forEach(function (item) {

          var currentValue = _this2.getValueFromPlujaStats(item, estats) || feature.properties["" + _this2.activeField + item.value];
          // console.log('sufCurrVal', currentValue, item)  
          var data = item.value !== "_calcvalue" ? _this2.getTimeStampFromCurrentValuePluja(currentValue, _newGA, item.value, timestampsLocal) : _this2.getCalcValuesInfo(timestampsLocal);
          if (item.value === "_calcvalue" && currentValue > 0) {
            currentValue = "+" + currentValue;
          }
          if (item.value !== "_value") {
            if (currentValue === null) {
              currentValue = "";
            }
            dateValuesObj[item.value] = {
              value: currentValue,
              date: data,
              text: item.text,
              suffix: item.value,
              color: item.color
            };
          }
        });
      } else {
        arraySufixActivates.forEach(function (item) {
          var currentValue = feature.properties["" + _this2.activeField + item.value];
          var data = item.value !== "_calcvalue" ? _this2.getTimeStampFromCurrentValue(currentValue, JSONActiveFiles, timestampsLocal) : _this2.getCalcValuesInfo(timestamps);
          if (item.value === "_calcvalue" && currentValue > 0) {
            currentValue = "+" + currentValue;
          }
          if (item.value !== "_value") {
            dateValuesObj[item.value] = {
              value: currentValue,
              date: data,
              text: item.text,
              suffix: item.value,
              color: item.color
            };
          }
        });
      }
      _newGA = _newGA.sort(function (a, b) {
        return a[0] - b[0];
      });
      var maxHValue = _newGA[_newGA.length - 1][0];
      var minHValue = _newGA[1][0];
      if (tipus === "today" || tipus === "latest" && maxHValue) {
        try {
          maxHValue.toString().split(" ");
          minHValue.toString().split(" ");
          //console.info("minValue1", minHValue);
        } catch (err) {
          maxHValue = _newGA[1][0];
          minHValue = _newGA[1][0];
          //console.info("minValue2", minHValue);
        }
        var hh = maxHValue.toString().split(" ");
        var hhn = minHValue.toString().split(" ");
        if (hh[4] && hh[4].indexOf(":") !== -1) {
          maxHValue = new Date(maxHValue.toString().replace(hh[4], "23:00:00"));
          minHValue = new Date(minHValue.toString().replace(hhn[4], "00:00:00"));
        }
        if (hh.length === 2) {
          maxHValue = new Date(maxHValue.toString().replace(hh[1], "23:00:00"));
          minHValue = new Date(minHValue.toString().replace(hhn[1], "00:00:00"));
        }
      }
      if (tipus === "latest" && !maxHValue) {
        var formatData = _share2.default.changeFormatArrayString([feature.properties.data_value]);
        _newGA[_newGA.length - 1][0] = new Date(formatData[0]);
        maxHValue = formatData[0];
        var _hh = maxHValue.toString().split(" ");
        var _hhn = maxHValue.toString().split(" ");
        if (_hh.length === 2) {
          maxHValue = new Date(maxHValue.toString().replace(_hh[1], "23:00:00"));
          minHValue = new Date(minHValue.toString().replace(_hhn[1], "00:00:00"));
        }
      }
      if (optionsField.max === optionsField.min) {
        optionsField.min = 0;
      }
      // console.info(_newGA);
      //console.info("grafic",_newGA);
      return {
        chartArray: _newGA,
        chartOptions: this.getChartOptions(optionsField, colorFont, colorBG, optionsField.min, optionsField.max, maxHValue, minHValue),
        optionsField: optionsField,
        dateValues: Object.values(dateValuesObj)
      };
    }
  }, {
    key: "getValueFromPlujaStats",
    value: function getValueFromPlujaStats(item, estats) {

      if (item.value === "_min") {
        return estats.basics.min;
      } else if (item.value === "_max") {
        return estats.basics.max;
      } else if (item.value === "_mean") {
        return estats.basics.mean;
        // } else if (item.value === "_value") {
      } else if (item.value === "_sum") {
        return estats.basics.sum;
      } else {
        return null;
      }
    }
  }, {
    key: "getChartOptions",
    value: function getChartOptions(optionsField, colorFont, colorBG, _Min, _Max, maxHValue, minHValue) {
      var colorBGHex = (0, _chromaJs2.default)(colorBG).hex();
      var colorFontHex = (0, _chromaJs2.default)(colorFont).hex();
      var options = {
        title: "",
        dateFormat: "YYYY-MM-DD HH (UTC)",
        tooltip: { isHtml: false },
        curveType: "function",
        legend: {
          position: "top",
          textStyle: {
            fontSize: 11,
            color: colorFontHex
          }
        },
        colors: [optionsField.color],
        chartArea: {
          width: "100%"
          /* height: "200px" */
        },
        backgroundColor: {
          fill: colorBGHex,
          stroke: colorFontHex
        },
        vAxis: {
          textStyle: {
            fontSize: 8,
            color: colorFontHex
          },
          gridlines: {
            count: 7
          },
          textPosition: "in",
          minValue: _Min,
          maxValue: _Max
        },
        hAxis: {
          gridlines: {
            count: 4
          },
          textPosition: "none",
          format: "YYYY-MM-DD HH (UTC)",
          //	minValue:minHValue,
          maxValue: maxHValue
        }
      };
      return options;
    }
  }, {
    key: "renderHeaderInfoWindow",
    value: function renderHeaderInfoWindow(colorBG, colorFont) {
      var title = this.props.featureInfo.properties && this.props.featureInfo.properties.nomok ? _utils2.default.cleanHtmlAccentsString(this.props.featureInfo.properties.nomok) : "Informació";
      var Alt = this.props.featureInfo.properties.alt;
      //console.info(Alt);
      //console.info(typeof Alt);
      if (typeof Alt === "string" && Alt.indexOf("{") != -1) {
        var rr = JSON.parse(Alt);
        //console.info(rr);
        Alt = rr["1"];
      }
      return _react2.default.createElement(
        _semanticUiReact.Message,
        {
          onDismiss: this.handleDismiss,
          onClick: this.handleDismiss,
          attached: true,
          style: { color: colorFont, backgroundColor: colorBG },
          className: _PanelGetFeatureInfo2.default.panelHeader
        },
        _react2.default.createElement(
          _semanticUiReact.Message.Header,
          null,
          title.replace(" " + this.props.featureInfo.properties.alt + "m", "")
        ),
        _react2.default.createElement(
          "p",
          null,
          _react2.default.createElement(
            "i",
            null,
            _utils2.default.cleanHtmlAccentsString(this.props.featureInfo.properties.comarca)
          ),
          " ",
          "(altitud: ",
          Alt,
          "m.)"
        )
      );
    }
  }, {
    key: "renderData",
    value: function renderData(colorFont) {
      if (this.props.timerange.tipus === CONSTANTS.LATEST || this.props.timerange.tipus === "") {
        var alias = this.props.selectedfieldsLabels;
        var feature = this.props.featureInfo;
        //console.info(feature.properties);
        return _react2.default.createElement(
          "div",
          {
            className: _PanelGetFeatureInfo2.default.containerOneItem,
            style: { color: colorFont, flex: ".5" }
          },
          _react2.default.createElement(
            "div",
            null,
            _react2.default.createElement(
              "p",
              null,
              alias[this.activeField]
            )
          ),
          _react2.default.createElement(
            "div",
            {
              className: _PanelGetFeatureInfo2.default.textShadow,
              style: { color: "black", fontSize: "2.5rem" }
            },
            _react2.default.createElement(
              "p",
              null,
              feature.properties[this.addSufixValue(this.activeField, "_value")]
            )
          ),
          _react2.default.createElement(
            "div",
            { className: _PanelGetFeatureInfo2.default.myLabelMedium },
            _react2.default.createElement(
              "p",
              null,
              feature.properties.data_value ? _share2.default.formatDateMoment(feature.properties.data_value) : ""
            )
          )
        );
      } else if (this.props.timerange.tipus === CONSTANTS.TODAY) {
        return _react2.default.createElement(
          "div",
          {
            style: {
              color: colorFont,
              flex: ".5",
              marginBottom: "0.5rem",
              textAlign: "center"
            }
          },
          _react2.default.createElement(
            "h5",
            null,
            "" + _share2.default.formatDateRange(this.props.timerange.timemax)
          )
        );
      }
      return _react2.default.createElement(
        "div",
        {
          style: {
            color: colorFont,
            flex: ".5",
            marginBottom: "0.5rem",
            textAlign: "center"
          }
        },
        _react2.default.createElement(
          "h5",
          null,
          _share2.default.formatDateRange(this.props.timerange.timemin) + " - " + _share2.default.formatDateRange(this.props.timerange.timemax)
        )
      );
    }
  }, {
    key: "renderValues",
    value: function renderValues(metaChart) {
      var _this3 = this;

      var itemValues = [];
      //  console.info("renderValues", metaChart);
      if (metaChart.optionsField.unitat) {
        metaChart.dateValues.forEach(function (item, index) {
          if (item.suffix === CONSTANTS.OPT_CALCULS_SUM && _this3.activeField.indexOf(CONSTANTS.CAMP_NOM_PLUJA) !== -1 || item.suffix !== CONSTANTS.OPT_CALCULS_SUM) {
            itemValues.push(_react2.default.createElement(
              "div",
              { className: _PanelGetFeatureInfo2.default.subpanelValuesItem, key: index },
              _react2.default.createElement(
                "div",
                null,
                item.text
              ),
              _react2.default.createElement(
                "div",
                {
                  className: _PanelGetFeatureInfo2.default.textShadowValues,
                  style: { color: item.color }
                },
                _react2.default.createElement(
                  "p",
                  null,
                  item.value + " " + metaChart.optionsField.unitat
                )
              ),
              _react2.default.createElement(
                "div",
                { id: item.text, className: _PanelGetFeatureInfo2.default.myLabelXSmall },
                item.date ? _share2.default.formatDateMoment(item.date) : _this3.getDaysRang()
              )
            ));
          }
        });
        return _react2.default.createElement(
          "div",
          { className: _PanelGetFeatureInfo2.default.subpanelFlexValues },
          itemValues
        );
      } else {
        return "";
      }
    }
  }, {
    key: "renderChart",
    value: function renderChart(metaChart) {
      //console.info("metaChart", metaChart);
      if (metaChart.optionsField.chartType) {
        return _react2.default.createElement(
          "div",
          { className: _PanelGetFeatureInfo2.default.subpanelChart },
          _react2.default.createElement(_reactGoogleCharts2.default, {
            chartType: metaChart.optionsField.chartType,
            formatters: [{
              type: "DateFormat",
              column: 0,
              options: { pattern: metaChart.optionsField.pattern }
            }],
            data: metaChart.chartArray,
            options: metaChart.chartOptions,
            chartLanguage: "ca"
          })
        );
      } else {
        return "";
      }
    }
  }, {
    key: "renderBodyFields",
    value: function renderBodyFields(colorFont, colorBG) {
      var feature = this.props.featureInfo;
      var timestamps = this.props.timerange.timestamps;
      if (!feature.properties) {
        return _react2.default.createElement(
          _semanticUiReact.Message,
          {
            info: true,
            size: "small",
            style: {
              color: colorFont,
              backgroundColor: colorBG,
              textAlign: "center",
              margin: "2rem"
            }
          },
          _react2.default.createElement(_semanticUiReact.Icon, { name: "info" }),
          "Sense propietats a mostrar"
        );
      }
      var metaChart = this.createArray(colorFont, colorBG);

      if (metaChart.optionsField.max === 4000) {} else {
        return _react2.default.createElement(
          "div",
          { className: _PanelGetFeatureInfo2.default.subpanelFlexColumn },
          this.renderData(colorFont),
          timestamps.length >= 1 && metaChart.dateValues.length > 0 && this.renderValues(metaChart),
          timestamps.length >= 1 && this.renderChart(metaChart)
        );
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          colorPanell = _props.colorPanell,
          colorPanellText = _props.colorPanellText,
          modeEdicio = _props.modeEdicio;

      var colorBG = "rgba(" + colorPanell.r + ", " + colorPanell.g + ", " + colorPanell.b + ", " + colorPanell.a + ")";
      var colorFont = "rgba(" + colorPanellText.r + ", " + colorPanellText.g + ", " + colorPanellText.b + ", " + colorPanellText.a + ")";
      var colorBgSaturate = (0, _chromaJs2.default)(colorBG).saturate(3);
      //const colorBgSaturate = Chroma(colorBG).set('lch.c', '*2');
      return _react2.default.createElement(
        "div",
        {
          className: modeEdicio || !this.props.viewTitleBar ? _PanelGetFeatureInfo2.default.panelGetFeatureInfo : _PanelGetFeatureInfo2.default.panelGetFeatureInfoVisor,
          style: { backgroundColor: colorBG, color: colorFont }
        },
        this.renderHeaderInfoWindow(colorBgSaturate, colorFont),
        this.renderBodyFields(colorFont, colorBG),
        this.renderFooterInfoWindow(colorFont, colorBgSaturate)
      );
    }
  }]);

  return PanelGetFeatureInfo;
}(_react.Component);

exports.default = PanelGetFeatureInfo;

PanelGetFeatureInfo.propTypes = {
  calcdatafieldsCalculs: _propTypes2.default.object,
  calcdatafieldsOptions: _propTypes2.default.object,
  data: _propTypes2.default.object,
  colorPanell: _propTypes2.default.object,
  colorPanellText: _propTypes2.default.object,
  selectedfieldsLabels: _propTypes2.default.object,
  timerange: _propTypes2.default.object,
  featureInfo: _propTypes2.default.object,
  thematics: _propTypes2.default.array,
  showGetFeatureInfo: _propTypes2.default.func,
  modeEdicio: _propTypes2.default.bool,
  viewTitleBar: _propTypes2.default.bool
};
